var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MakhazinApi } from '../../Api';
import useApiAbort from '../../Api/Core/useApiAbort';
import ActionBar from '../../Components/ActionBar';
import { EmailField, PasswordField, UsernameField } from '../../Components/Field';
import { useUserContext } from '../../Context/UserContext';
import { useStyles } from './UserLoginForm.styles';
function validateUsername(username) {
    if (username.length === 0)
        return false;
    return true;
}
function validateFields(username, password) {
    if (username.length === 0)
        return false;
    if (password.length === 0)
        return false;
    return true;
}
export const LoginForm = (props) => {
    const abortController = useApiAbort();
    const loginUser = useUserContext().loginUser;
    const [username, setUsername] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const [validForm, setValidForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [forgotPassword, setForgotPassword] = useState(false);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        if (username && (password || forgotPassword)) {
            let valid = false;
            if (password) {
                valid = validateFields(username, password);
            }
            else {
                valid = validateUsername(username);
            }
            setValidForm(valid);
        }
        else {
            setValidForm(false);
        }
    }, [username, password, forgotPassword]);
    const handleUsernameChange = (input) => {
        setUsername(input);
    };
    const handlePasswordChange = (input) => {
        setPassword(input);
    };
    const handleLogin = () => __awaiter(void 0, void 0, void 0, function* () {
        var user;
        setLoading(true);
        if (validForm) {
            try {
                user = yield new MakhazinApi(abortController.current).authUser(username, password);
            }
            catch (error) {
                if (!abortController.current.signal.aborted) {
                    props.errorMessage('Felaktigt användarnamn eller lösenord');
                    setValidForm(false);
                }
            }
        }
        setLoading(false);
        if (user) {
            navigate(loginUser(user, user.accessToken, user.refreshToken));
        }
    });
    const handleForgotPassword = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (validForm) {
            try {
                yield new MakhazinApi(abortController.current).resetPassword(username);
                enqueueSnackbar(`Ett meddelande har gått iväg till e-postadressen ${username} med instruktioner om hur du byter ditt lösenord`, {
                    variant: 'info',
                    persist: true,
                    preventDuplicate: true,
                });
            }
            catch (error) {
                if (!abortController.current.signal.aborted) {
                    props.errorMessage('Något gick fel');
                    setValidForm(false);
                }
            }
        }
        setLoading(false);
        navigate('/login');
    });
    const classes = useStyles();
    const handleFormSubmit = (event) => {
        event.preventDefault();
        handleLogin();
        return false;
    };
    return (React.createElement("section", null, (!forgotPassword && (React.createElement("form", { action: '#', onSubmit: handleFormSubmit },
        React.createElement(Grid, { container: true, direction: "column", alignItems: "center" },
            React.createElement(Box, { component: "div", sx: classes.container },
                React.createElement(UsernameField, { label: "E-mail", placeholder: "Fyll i e-mail", value: username, onChange: handleUsernameChange }),
                React.createElement(PasswordField, { label: "L\u00F6senord", value: password, onChange: handlePasswordChange }),
                React.createElement(Button, { sx: classes.forgotPassword, onClick: () => setForgotPassword(true) }, "Gl\u00F6mt l\u00F6senord?")),
            (!loading && (React.createElement(ActionBar, { isSubmit: true, customText: "Logga in", navigateForward: handleLogin, disabled: !validForm }))) || React.createElement(CircularProgress, null))))) || (React.createElement("form", null,
        React.createElement(Grid, { container: true, direction: "column", alignItems: "center" },
            React.createElement(Typography, { variant: "h4" }, "\u00C5terst\u00E4ll ditt l\u00F6senord"),
            React.createElement("br", null),
            React.createElement(Box, { component: "div", sx: classes.container },
                React.createElement(EmailField, { label: "E-mail", value: username, onChange: handleUsernameChange })),
            (!loading && (React.createElement(ActionBar, { customText: "Skicka", navigateForward: handleForgotPassword, disabled: !validForm }))) || React.createElement(CircularProgress, null),
            React.createElement("br", null),
            React.createElement(Link, { sx: classes.forgotPassword, onClick: () => setForgotPassword(false), href: "#" }, "Tillbaka till inloggning"))))));
};
export default LoginForm;
